import { Component } from '@angular/core';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SidebarService } from '../app/core/services/sidebar.service';
import { environment } from '../environments/environment';
import { AuthenticationService } from './core/services/authentication.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    animations: [
        trigger('slideInOut', [
            state('in', style({
                transform: 'translate3d(0, 0, 0)'
            })),
            state('out', style({
                transform: 'translate3d(100%, 0, 0)'
            })),
            transition('in => out', animate('400ms ease-in-out')),
            transition('out => in', animate('400ms ease-in-out'))
        ]),
    ],
    standalone: false
})
export class AppComponent {   
    title = 'app';
    public currentYear: number = new Date().getFullYear();

    isProd = environment.production;
    //HasChrome and theme here to support Teams chromeless widget
    hasChrome = true;
    theme: string = undefined;

    constructor(
        public sidebarService: SidebarService,
        public auth: AuthenticationService,
        private route: ActivatedRoute,
        private router: Router, 
        private modalService: NgbModal,
    ) {
        this.route.queryParamMap
            .subscribe(params => {
                //  This is so we can apply theming to match Teams - https://docs.microsoft.com/en-us/microsoftteams/platform/tabs/how-to/access-teams-context
                if (params.get('theme'))
                    this.theme = "teams-" + params.get('theme');
            });
    }


    ngOnInit() {
        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {

                // close all open modals
                this.modalService.dismissAll();

            }
        });
    }

    public get isInspector(): boolean {
        return this.auth.token && this.auth.token.isFound && this.auth.token.payload["Kfbs.Environment.View"];
    }

    public isDashboard() {
        var url = this.router.url;

        if (url.indexOf('dashboard') != -1)
            return true
        return false;

        //return this.router.url === '/dashboard';
    }
}
